import { cashFlowSettingsSchema } from "../../../../../../../api/schemas/biClientSchema.ts";
import type { CashFlowSettingsConfiguration, TabularGeneralSettings } from "../../../../../../../api/types/svTypes.ts";

export const getCashFlowSettings = (settings: TabularGeneralSettings): CashFlowSettingsConfiguration =>
  settings.cashFlow ?? cashFlowSettingsSchema.parse({});
